/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Journey_Link_FailedInputs */



/**
* | output |
* | --- |
* | "Linking did not work. Try again in a moment." |
*
* @param {Journey_Link_FailedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const journey_link_failed = /** @type {((inputs?: Journey_Link_FailedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Journey_Link_FailedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Koppelen is niet gelukt. Probeer het zo opnieuw.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'association n'a pas fonctionné. Réessayez dans un instant.")
	return /** @type {LocalizedString} */ ("Linking did not work. Try again in a moment.")
});